import Http from "../../../../../core/http-axios-react/http/Http";
import { HttpBaseRequest } from "../../../../../core/HttpRequest";
import { HttpBaseResponse, HttpData } from "../../../../../core/HttpResponse";
import { Form_Create_Stock } from "../../../form/FormStockAdjusment";
import { M_Stock } from "../../../type/Produk.type";

export interface Http_GET_StockHistory extends HttpBaseRequest {
  product_id: string;
}

export const getStockHistory = async ({
  product_id,
  keyword,
  page,
  perPage,
}: Http_GET_StockHistory) => {
  const result = await Http.get<HttpBaseResponse<HttpData<M_Stock[]>>>({
    url: "/product/stock",
    params: {
      product_id,
      keyword,
      page,
      perPage,
    },
  });
  return result;
};

export const addStockHistory = async ({
  description,
  product_id,
  quantity,
}: Form_Create_Stock) => {
  const result = await Http.post({
    url: "/product/stock/insert",
    data: {
      product_id,
      description,
      quantity,
    },
  });
  return result;
};
